import { observer } from 'mobx-react';
import { FC, useMemo } from 'react';
import Skeleton from 'react-loading-skeleton';
import { orderProductModalStore } from '../../store/orderProductModalStore';
import { localeStore } from 'src/mobx/localesStore';
import { BUTTON_TITLE } from '~/constants/main';
import Button from '~/view/components/Controls/ButtonComponent/Button';
import './style.scss';

const ProductSubmit: FC = observer((): JSX.Element => {
  const { product, productError, mealComboError, onSubmit } = orderProductModalStore;

  const submitButtonTitle = useMemo((): string => localeStore.t(product?.hash ? BUTTON_TITLE.SAVE : BUTTON_TITLE.ADD), [product]);

  const isDisabled = useMemo((): boolean => {
    return Boolean(!product || productError || mealComboError);
  }, [orderProductModalStore.product, orderProductModalStore.productError, orderProductModalStore.mealComboError]);

  if (!orderProductModalStore.product) {
    return (
      <div className="full-width">
        <Skeleton width="100%" height={60} style={{ borderRadius: 16 }} />
      </div>
    );
  }

  return <Button id="product_submit" title={submitButtonTitle} size="large" onClick={onSubmit} disabled={isDisabled} stretched />;
});

export default ProductSubmit;
